var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospitalUserSolid1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 107,
    viewBox: "0 0 120 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.47917 0 0 4.47917 0 10V53.3333H30C31.8333 53.3333 33.3333 54.8333 33.3333 56.6667C33.3333 58.5 31.8333 60 30 60H0V73.3333H30C31.8333 73.3333 33.3333 74.8333 33.3333 76.6667C33.3333 78.5 31.8333 80 30 80H0V96.6667C0 102.188 4.47917 106.667 10 106.667H55.3958C54.0833 104.542 53.3333 102.042 53.3333 99.3542C53.3333 89.5833 58.7083 81.0625 66.6667 76.6042V56.625V10C66.6667 4.47917 62.1875 0 56.6667 0H10ZM31.6667 13.3333H35C36.8333 13.3333 38.3333 14.8333 38.3333 16.6667V21.6667H43.3333C45.1667 21.6667 46.6667 23.1667 46.6667 25V28.3333C46.6667 30.1667 45.1667 31.6667 43.3333 31.6667H38.3333V36.6667C38.3333 38.5 36.8333 40 35 40H31.6667C29.8333 40 28.3333 38.5 28.3333 36.6667V31.6667H23.3333C21.5 31.6667 20 30.1667 20 28.3333V25C20 23.1667 21.5 21.6667 23.3333 21.6667H28.3333V16.6667C28.3333 14.8333 29.8333 13.3333 31.6667 13.3333ZM106.667 56.6667C106.667 52.2464 104.911 48.0072 101.785 44.8816C98.6595 41.7559 94.4203 40 90 40C85.5797 40 81.3405 41.7559 78.2149 44.8816C75.0893 48.0072 73.3333 52.2464 73.3333 56.6667C73.3333 61.0869 75.0893 65.3262 78.2149 68.4518C81.3405 71.5774 85.5797 73.3333 90 73.3333C94.4203 73.3333 98.6595 71.5774 101.785 68.4518C104.911 65.3262 106.667 61.0869 106.667 56.6667ZM60 99.3958C60 103.417 63.25 106.667 67.2708 106.667H112.729C116.75 106.667 120 103.417 120 99.3958C120 88.6875 111.312 80 100.604 80H79.3958C68.6875 80 60 88.6875 60 99.3958Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 106.667,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalUserSolid1);
export default __webpack_public_path__ + "static/media/hospital-user-solid 1.0744e80384fd22f1429e58ed8855016c.svg";
export { ForwardRef as ReactComponent };